<template>
<n-card
    size="small"
    :bordered="false"
    class="overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg"
    :segmented="{
      content: true,
      footer: 'soft'
    }">
    <template #default>
        <div class="border border-dashed border-gray-600 rounded-md flex flex-col items-center py-6">
            <Bots__running class="w-24 fill-current" />
            <div class="notes text-center text-gray-600 dark:text-white/75 mt-2" v-html="bots.localization['bots_how_to_create_bot']"></div>

            <section class="flex items-center mt-4">
                <n-button
                    strong
                    class="text-white/90 rounded-md"
                    :color="gl.mainColor"
                    @click="router.push({ name: 'bots.create' })">
                    + {{ bots.localization['bot_create_button'] }}
                </n-button>
                <section class="flex items-center mx-2">
                    <div class="border-b border-gray-200 dark:border-gray-600 w-[16px]"></div>
                    <div class="text-gray-600 dark:text-white/75 px-2">{{ t('or') }}</div>
                    <div class="border-b border-gray-200 dark:border-gray-600 w-[16px]"></div>
                </section>
                <n-button
                    strong
                    secondary
                    class="rounded-md"
                    @click="showCreateModalFormConfig = true">
                    <n-tag round size="small" type="warning" class="mr-2">
                        <span class="text-yellow-500 font-semibold text-sm">new</span>
                    </n-tag>
                    {{ bots.localization?.['choose_config_file'] || 'Выбрать файл конфигурации' }}
                </n-button>
            </section>
        </div>
    </template>
</n-card>
<div v-if="!init" class="flex h-full justify-center items-center py-60">
    <n-spin size="small" />
</div>
<super-table
    v-else
    showSearch
    :filters="filters"
    :actions="actions"
    :refFilters="refFilters"
    :pager="bots.pager"
    :columns="columns"
    :loading="loadings.table"
    :records="bots.records"
    :filtersChanged="filtersChanged"
    columnsStorageName="__columns_bots"
    type="bots"
    @getData="getData"
    @doSomething="doSomething"
    @reset-filters="resetFilters"
    @applyFilters="changeFilter"
    @updateTags="updateTags">
    <template #tableTitle>
        <div class="text-base text-left mb-2 text-gray-600 dark:text-white/75">
            {{ bots.localization['available_bots_table_title'] }}
        </div>
    </template>
    <template #stats>
        <n-card
            size="small"
            :bordered="false"
            class="shadow bg-white dark:bg-darkCardBg rounded-lg my-3"
            :segmented="{
                content: true,
                footer: 'soft'
            }">
            <div class="text-md text-gray-600 dark:text-white/75">
                <span>{{ bots.localization['available_bots_total'] }}</span>
                <n-tag round size="small" :bordered="false" type="warning" class="ml-2">
                    <span class="text-yellow-500 font-semibold">{{ bots.dataTable.stats.total }}</span>
                </n-tag>
                <span class="ml-4">{{ bots.localization['available_bots_running'] }}</span>
                <n-tag round size="small" :bordered="false" type="success" class="ml-2">
                    <span class="text-green-500 font-semibold">{{ bots.dataTable.stats.running }}</span>
                </n-tag>
                
                <span class="ml-4">{{ bots.localization['available_bots_stopped'] }}</span>
                <n-tag round size="small" :bordered="false" class="ml-2">
                    <span class="font-semibold">{{ bots.dataTable.stats.stopped }}</span>
                </n-tag>
                
                <span class="ml-4">{{ bots.localization['available_bots_archived'] }}</span>
                <n-tag round size="small" :bordered="false" type="info" class="ml-2">
                    <span class="text-blue-500 font-semibold">{{ bots.dataTable.stats.archived }}</span>
                </n-tag>

                <span class="ml-4">{{ bots.localization['available_bots_error'] }}</span>
                <n-tag round size="small" :bordered="false" type="error" class="ml-2">
                    <span class="text-red-400 font-semibold">{{ bots.dataTable.stats.error }}</span>
                </n-tag>
            </div>
        </n-card>
    </template>
    <template #actionButtons>
        <section v-if="bots.records.length" class="flex">
            <n-button
                strong
                class="text-white/90 rounded-md"
                :color="gl.mainColor"
                :disabled="!actionButtonsDisabled"
                @click="letsShowConfirmation('start')">
                {{ bots.localization['available_bots_table_mass_start_button'] }}
            </n-button>
            <n-button
                strong
                class="ml-3 text-white/90 rounded-md"
                :color="gl.mainColor"
                :disabled="!actionButtonsDisabled"
                @click="letsShowConfirmation('stop')">
                {{ bots.localization['available_bots_table_mass_stop_button'] }}
            </n-button>
            <n-button
                strong
                class="ml-3 text-white/90 rounded-md"
                :color="gl.mainColor"
                :disabled="!actionButtonsDisabled"
                @click="letsShowConfirmation('pause')">
                {{ bots.localization['available_bots_table_mass_pause_button'] }}
            </n-button>
            <n-button
                strong
                class="ml-3 text-white/90 rounded-md"
                :color="gl.mainColor"
                :disabled="!actionButtonsDisabled"
                @click="letsShowConfirmation('archive')">
                {{ bots.localization['available_bots_table_mass_archive_button'] }}
            </n-button>
            <n-button
                strong
                class="ml-3 text-white/90 rounded-md"
                :color="gl.mainColor"
                :disabled="!actionButtonsDisabled"
                @click="letsShowConfirmation('delete')">
                {{ bots.localization['available_bots_table_mass_delete_button'] }}
            </n-button>
            <section class="flex items-center ml-3">
                <n-button
                    strong
                    secondary
                    class="rounded-md"
                    :disabled="checkedCountBots > 10 || checkedCountBots < 1 || showEditingNotMessages"
                    @click="openPackageEditing">
                    <n-tag round size="small" type="warning" class="mr-2">
                        <span class="text-yellow-500 font-semibold text-sm">new</span>
                    </n-tag>
                    {{ bots.localization?.['package_editing'] || 'Пакетное редактирование' }}
                </n-button>
                <n-popover
                    v-if="showEditingNotMessages"
                    trigger="hover"
                    class="lg:max-w-[300px] max-w-[180px] lg:max-h-[400px] max-h-[180px] rounded-md overflow-auto bg-yellow-600"
                    placement="top">
                    <template #trigger>
                        <n-icon class="text-lg cursor-pointer text-yellow-600 ml-2" >
                            <Warning24Filled />
                        </n-icon>
                    </template>
                    <span
                        v-if="packageEditingNotLess"
                        class="text-[10px] lg:text-xs text-white" v-html="bots.localization?.package_editing_not_less || 'Выберите больше одного бота'">
                    </span>
                    <span
                        v-if="packageEditingNotMore"
                        class="text-[10px] lg:text-xs text-white" v-html="bots.localization?.package_editing_not_more || 'Вы не можете редактировать больше 10 ботов за раз'">
                    </span>
                    <span
                        v-if="packageEditingNotSameAlgo" class="text-[10px] lg:text-xs text-white"
                        v-html="bots.localization?.package_editing_not_same_algo || 'Вы не можете редактировать боты с разными алгоритмами'">
                    </span>
                </n-popover>
            </section>
        </section>
    </template>
</super-table>

<base-dialog-desktop
    v-model:show="showConfirmation"
    @positive-click="showConfirmation = false, groupAction(actionType)"
    @negative-click="showConfirmation = false">
    <div class="text-md" v-html="refs.localization.confirmations.bot[actionType]"></div>
</base-dialog-desktop>

<bot-clone-more
    :botId="cloneMoreShowId"
    @update:bot-id="cloneMoreShowId = $event"
    :localization="bots.localization"
    @oneBotIsDone="oneBotIsDone($event)" />

<bot-json-copy
    v-model:show="showCreateModalFormConfig" />

<bot-package-editing
    :checked-bots="checkedBots"
    v-model:show="showPackageEditing"/>
</template>

<script>
// general
import general from './general';

// components
import SuperTable from '@components/super-table/desktop.vue';
import Bots__running from '@components/svg/Bots__running.vue';
import BotCloneMore from '@components/bots/childs/bot-clone-more';
import BotJsonCopy from '@components/bots/childs/bot-json-copy';
import BotPackageEditing from '@components/bots/childs/bot-package-editing';

// icons
import {
    Warning24Filled } from '@vicons/fluent';

// naive-ui
import {
    NTag,
    NIcon,
    NSpin,
    NCard,
    NButton,
    NPopover } from 'naive-ui';

export default {
    name: 'bots-review-desktop',
    components: {
        NTag,
        NSpin,
        NCard,
        NIcon,
        NButton,
        NPopover,
        SuperTable,
        BotJsonCopy,
        BotCloneMore,
        Bots__running,
        Warning24Filled,
        BotPackageEditing,
    },
    setup(props, context) {
        
        return {
            ...general(arguments),
        };
    },
};
</script>